/* Auth */
export const SET_APIS = 'SET_APIS'
export const SET_ENVIRONMENT = 'SET_ENVIRONMENT'
export const SET_GOOGLE_MAPS_API_KEY = 'SET_GOOGLE_MAPS_API_KEY'
export const SET_LOGIN_URL = 'SET_LOGIN_URL'
export const SET_USER_TOKEN = 'SET_USER_TOKEN'
export const SET_ACCOUNT_TOKEN = 'SET_ACCOUNT_TOKEN'
export const SET_APP_ID = 'SET_APP_ID'
export const SET_APP_SECRET = 'SET_APP_SECRET'

/* Permissions */
export const SET_PERMISSIONS = 'SET_PERMISSIONS'

/* Stores */
export const SET_STORE_LOCATIONS = 'SET_STORE_LOCATIONS'
export const SET_ACTIVE_LOCATION = 'SET_ACTIVE_LOCATION'

/* Combos */
export const SET_COMBO_OFFER = 'SET_COMBO_OFFER'
export const CLEAR_COMBO_OFFER = 'CLEAR_COMBO_OFFER'

/* Users */
export const SET_USER = 'SET_USER'
export const CLEAR_USER = 'CLEAR_USER'
